var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy',{key:_vm.values.id,attrs:{"options":{ threshold: 0.5 }},model:{value:(_vm.lazy),callback:function ($$v) {_vm.lazy=$$v},expression:"lazy"}},[(_vm.lazy)?_c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"green"}}):_c('span',[_vm._v(" "+_vm._s(_vm.saldo)+" ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }